import React from 'react';

const AgeChip = ({ value }) => {
  return <>{value?.join(' - ')}</>;
};

export default AgeChip;
